import React from "react";

import { InfoSmIcon } from "@packages/ds";

import AdminTag from "Components/AdminTag/AdminTag";
import { IconControl, Link } from "ds/Button";
import Dialog from "ds/Dialog";
import * as Sticker from "ds/Sticker";

import { InfoLinkContainer } from "./Overview.styles";

type InfoProps = {
  title?: string;
  description?: string | React.ReactNode;
  links?: Array<{
    text: string;
    href?: string;
    target?: string;
    to?: string;
    variant?:
      | "link"
      | "primary"
      | "secondary"
      | "outline"
      | "linkSecondary"
      | "critical"
      | "dark"
      | undefined;
  }>;
  align?: "start" | "center" | "end";
  analyticId?: string;
  tag?: boolean;
  tooltip?: React.ReactNode;
  sticker?: { message: string; priority: Sticker.Priority };
};

const EnvironmmentStatusInfo = (prop: InfoProps) => {
  const links = prop.links?.map(({ text, to, href, target, variant }) => {
    if (to) {
      // Router Link
      return (
        <Link key={text} variant={variant} to={to} analyticId={text}>
          {text}
        </Link>
      );
    } else if (href) {
      // Anchor Link
      return (
        <Link
          key={text}
          href={href}
          target={target}
          variant={variant}
          analyticId={text}
        >
          {text}
        </Link>
      );
    }
    return null;
  });

  const sticker = prop.sticker && (
    <Sticker.Root priority={prop.sticker.priority}>
      <Sticker.Icon priority={prop.sticker.priority} />
      <Sticker.Text>{prop.sticker.message}</Sticker.Text>
    </Sticker.Root>
  );

  const tag = prop.tag && <AdminTag />;
  return (
    <Dialog
      analyticId={prop.analyticId}
      title={prop.title}
      description={prop.description}
      link={<InfoLinkContainer>{links}</InfoLinkContainer>}
      sticker={sticker}
      tag={tag}
      tooltip={prop.tooltip}
      align={prop.align}
      trigger={
        <IconControl aria-label="info-control">
          <InfoSmIcon />
        </IconControl>
      }
    />
  );
};

export default EnvironmmentStatusInfo;
